import React from "react"
import { ResumoFornecedorInicial, type ResumoFornecedorModel } from "../models/resumoFornecedorModel"
import type { ResumoFornecedorAction } from "./resumoFornecedorActions"

type ResumoFornecedorContextType = {
    dados: ResumoFornecedorModel
    dispatch: React.Dispatch<ResumoFornecedorAction>
    erroCarregamento: string | null
    carregando: boolean
    buscar: () => Promise<void>
    buscarInicial: () => Promise<void>
    carregouInicial: boolean
}

export const ResumoFornecedorContext = React.createContext<ResumoFornecedorContextType>({
    dados: ResumoFornecedorInicial,
    dispatch: () => undefined,
    erroCarregamento: null,
    carregando: false,
    buscar: async () => undefined,
    buscarInicial: async () => undefined,
    carregouInicial: false,
})
